import React from 'react';
import { Provider } from '../react-redux';
import store from '../../reduxStore';
import Timer from './layout/header/Timer';
import PropTypes from 'prop-types';
export var SDKTimer = function SDKTimer(_ref) {
  var iceTopNavBarEnabled = _ref.iceTopNavBarEnabled,
    setTimerEnabled = _ref.setTimerEnabled;
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(Timer, {
    iceTopNavBarEnabled: iceTopNavBarEnabled,
    setTimerEnabled: setTimerEnabled
  }));
};
Timer.propTypes = {
  iceTopNavBarEnabled: PropTypes.bool
};
Timer.defaultProps = {
  iceTopNavBarEnabled: false
};
SDKTimer.displayName = 'SDKTimer';
export default SDKTimer;